import React, { useState, useEffect } from "react";
import {
  Sidebar,
  Menu,
  MenuItem,
  SubMenu,
  sidebarClasses,
} from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import "./Sidenav.css";
import {
  UserRoundCog,
  Users,
  House,
  Gauge,
  BookOpenCheck,
  UserRound,
  Briefcase,
  Award,
  HandCoins,
  Percent,
  PersonStanding,
  Handshake,
  ReceiptIndianRupee,
  Joystick,
  CloudSun,
  Building2,
  ReceiptText,
  HandHelping,
  WalletCards,
  PackageSearch,
  NotebookTabs,
  BriefcaseBusiness,
  FileClock,
  Layers3,
  CirclePercent,
  NotebookPen,
  MarsStroke,
} from "lucide-react";
import Solar_logo from "../images/Solar_logo.webp";
function Sidenav(props) {
  // const permissions = localStorage.getItem('permissions');
  const location = useLocation();
  const [logo, setLogo] = useState(true);
  const userId = localStorage.getItem("userId");

  const isAnySubModuleActive = (subModules) =>
    subModules.some((subModule) =>
      location.pathname.includes(subModule.replace(" ", "-"))
    );

  useEffect(() => {
    setLogo(!logo);
  }, [props.isSidebarCollapsed]);

  const customMenuItemStyles = {
    button: {
      color: "#00000",
      paddingLeft: 0,
    },
    psMenuButton: {
      marginLeft: "0px !important",
      height: "40px !important",
    },
  };

  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

  const modulesToShow = permissions
    .filter((module) =>
      Object.values(module).some(
        (value) => value === true && typeof value === "boolean"
      )
    )
    .map((module) => module.moduleName.toLowerCase());
  const isModuleVisible = (moduleName) => modulesToShow.includes(moduleName);
  const shouldShowParent = (subModules) => subModules.some(isModuleVisible);

  return (
    <div style={{ height: "100vh" }} className="d-none d-sm-block">
      <Sidebar
        collapsed={props.isSidebarCollapsed}
        width="200px"
        collapsedWidth="40px"
        rootStyles={{
          [`.${sidebarClasses.container}`]: {
            backgroundColor: "#023233",
            color: "white",
            minHeight: "100vh",
          },
        }}
      >
        <Menu menuItemStyles={customMenuItemStyles}>
          <div className="logo-div">
            {!logo ? (
              <span className="mx-1 my-2">
                <img src={Solar_logo} />
                {/* <img src="https://i.ibb.co/pj8jyqYc/solar-logo.webp" /> */}
              </span>
            ) : (
              <span className="">
                <img src={Solar_logo} />
                {/* <img src="https://i.ibb.co/pj8jyqYc/solar-logo.webp" /> */}
              </span>
            )}
          </div>
          <div className="custom-scroll" style={{ maxHeight: "90vh" }}>
            <MenuItem
              icon={<House size={20} />}
              component={<Link to="/home" />}
              className={
                location.pathname === "/home" ? "menu-item active" : "menu-item"
              }
            >
              Home
            </MenuItem>
            {shouldShowParent([
              "lead",
              "deal",
              "client",
              "company",
              "quote",
              "walkthrough",
              "task master",
              "dms master",
            ]) && (
              <SubMenu
                label="CRM"
                icon={<UserRoundCog size={20} />}
                className={
                  isAnySubModuleActive([
                    "lead",
                    "deal",
                    "client",
                    "company",
                    "quote",
                    "walkthrough",
                    "task master",
                    "dms master",
                  ])
                    ? "submenu-active"
                    : ""
                }
              >
                {isModuleVisible("lead") && (
                  <MenuItem
                    icon={<Percent size={20} />}
                    component={<Link to="/lead-list" />}
                    className={
                      location.pathname === "/lead-list" ||
                      location.pathname === "/lead-detail-view"
                        ? "menu-item active"
                        : "menu-item"
                    }
                  >
                    Leads
                  </MenuItem>
                )}
                {isModuleVisible("lead" || "deal") && (
                  <MenuItem
                    icon={<Briefcase size={20} />}
                    component={<Link to="/deal-list" />}
                    className={
                      location.pathname === "/deal-list" ||
                      location.pathname === "/deal-detail-view"
                        ? "menu-item active"
                        : "menu-item"
                    }
                  >
                    Deals
                  </MenuItem>
                )}
                {isModuleVisible("client") && (
                  <MenuItem
                    icon={<Handshake size={20} />}
                    component={<Link to="/client-list" />}
                    className={
                      location.pathname === "/client-list" ||
                      location.pathname === "/client-detail-view"
                        ? "menu-item active"
                        : "menu-item"
                    }
                  >
                    Clients
                  </MenuItem>
                )}
                {isModuleVisible("company") && (
                  <MenuItem
                    icon={<Building2 size={20} />}
                    component={<Link to="/company-list" />}
                    className={
                      location.pathname === "/company-list" ||
                      location.pathname === "/company-detail-view"
                        ? "menu-item active"
                        : "menu-item"
                    }
                  >
                    Companies
                  </MenuItem>
                )}
                {isModuleVisible("quote") && (
                  <MenuItem
                    icon={<HandHelping size={20} />}
                    component={<Link to="/quote-list" />}
                    className={
                      location.pathname === "/quote-list" ||
                      location.pathname === "/quote-detail-view"
                        ? "menu-item active"
                        : "menu-item"
                    }
                  >
                    Quote
                  </MenuItem>
                )}
                {isModuleVisible("walkthrough") && (
                  <MenuItem
                    icon={<PersonStanding size={20} />}
                    component={<Link to="/walkthrough" />}
                    className={
                      location.pathname === "/walkthrough" ||
                      location.pathname === "/walkthrough-detail-view"
                        ? "menu-item active"
                        : "menu-item"
                    }
                  >
                    Walkthroughs
                  </MenuItem>
                )}
                {isModuleVisible("task master") && (
                  <MenuItem
                    icon={<BookOpenCheck tanding size={20} />}
                    component={<Link to="/taskmaster" />}
                    className={
                      location.pathname === "/taskmaster" ||
                      location.pathname === "/taskmaster-detail-view"
                        ? "menu-item active"
                        : "menu-item"
                    }
                  >
                    Task Master
                  </MenuItem>
                )}
                {isModuleVisible("dms master") && (
                  <MenuItem
                    icon={<MarsStroke tanding size={20} />}
                    component={<Link to="/dmsmaster" />}
                    className={
                      location.pathname === "/dmsmaster" ||
                      location.pathname === "/dmsmaster-detail-view"
                        ? "menu-item active"
                        : "menu-item"
                    }
                  >
                    DMS Master
                  </MenuItem>
                )}
              </SubMenu>
            )}
            {shouldShowParent(["site", "survey", "inspection", "map"]) && (
              <SubMenu
                label="Operations"
                icon={<Layers3 size={20} />}
                className={
                  isAnySubModuleActive([
                    "survey-list-view",
                    "survey-detail-view",
                    "sites",
                    "site-detail-view",
                    "inspection",
                    "inspection-detail",
                    "map",
                  ])
                    ? "submenu-active"
                    : ""
                }
              >
                {/* {isModuleVisible("survey") && (
                <MenuItem icon={<LayoutList size={20} />} component={<Link to="/survey-list-view" />} className={location.pathname.includes("survey") ? "menu-item active" : "menu-item"}>Survey</MenuItem>
              )} */}
                {isModuleVisible("site") && (
                  <MenuItem
                    icon={<Briefcase size={20} />}
                    component={<Link to="/sites" />}
                    className={
                      location.pathname.includes("site")
                        ? "menu-item active"
                        : "menu-item"
                    }
                  >
                    Sites
                  </MenuItem>
                )}
                {/* {isModuleVisible("inspection") && (
                <MenuItem icon={<ShieldAlert size={20} />} component={<Link to="/inspection" />} className={location.pathname.includes("inspection") ? "menu-item active" : "menu-item"}>Inspections</MenuItem>
              )} */}
                {/* {isModuleVisible("map") && (
                <MenuItem icon={<MapPinned size={20} />} component={<Link to="/map" />} className={location.pathname.includes("map") ? "menu-item active" : "menu-item"}>Map</MenuItem>
              )} */}
              </SubMenu>
            )}
            {/* Finance Menu */}

            {shouldShowParent([
              "sales order",
              "invoice",
              "vendor",
              "purchase order",
              "bill",
              "inventory",
              "customer ledger",
              "terms-and-condition",
              "prize",
              "payment receive",
            ]) && (
              <SubMenu
                label="Finance"
                icon={<HandCoins size={20} />}
                className={
                  isAnySubModuleActive([
                    "sales-order",
                    "salesorder-detail-view",
                    "invoice",
                    "invoice-detail-view",
                    "vendor",
                    "purchaseOrder-list-view",
                    "purchaseOrder-detail-view",
                    "bill",
                    "inventory",
                    "customer-ledger",
                    "terms-and-condition",
                    "prize",
                    "payment-receive",
                    "payment-receive-detail",
                  ])
                    ? "submenu-active"
                    : ""
                }
              >
                <SubMenu
                  label="Inventory Masters"
                  icon={<UserRoundCog size={20} />}
                  style={{ marginLeft: "15px" }}
                  className={
                    isAnySubModuleActive([
                      // "inventory",
                      "price",
                      "masters",
                    ])
                      ? "submenu-active"
                      : ""
                  }
                >
                  {/* Inventory */}
                  {isModuleVisible("inventory") && (
                    <MenuItem
                      icon={<PackageSearch size={17} />}
                      component={<Link to="/inventory" />}
                      className={
                        location.pathname.includes("inventory")
                          ? "menu-item active"
                          : "menu-item"
                      }
                      style={{ marginLeft: "40px" }}
                    >
                      Inventory
                    </MenuItem>
                  )}

                  {/* {isModuleVisible("prize") && ( */}
                  <MenuItem
                    icon={<ReceiptIndianRupee size={17} />}
                    component={<Link to="/price-list" />}
                    className={
                      location.pathname.includes("price")
                        ? "menu-item active"
                        : "menu-item"
                    }
                    style={{ marginLeft: "40px" }}
                  >
                    Price List
                  </MenuItem>
                  {/* )} */}

                  {/* {isModuleVisible("panel") && ( */}
                  {/* <MenuItem icon={<CloudSun size={17} />} component={<Link to="/panel-list" />} className={location.pathname.includes("panel") ? "menu-item active" : "menu-item"} style={{ marginLeft: "40px" }}>
                    Panel
                  </MenuItem> */}

                  <MenuItem
                    icon={<Joystick size={17} />}
                    component={<Link to="/masters-list" />}
                    className={
                      location.pathname.includes("masters")
                        ? "menu-item active"
                        : "menu-item"
                    }
                    style={{ marginLeft: "40px" }}
                  >
                    Master
                  </MenuItem>
                  {/* )} */}
                </SubMenu>
                <MenuItem
                  icon={<PackageSearch size={20} />}
                  component={<Link to="/customerLedger" />}
                  className={
                    location.pathname.includes("customer-ledger")
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  Customer Ledger
                </MenuItem>
                <MenuItem
                  icon={<PackageSearch size={20} />}
                  component={<Link to="/term&condition" />}
                  className={
                    location.pathname.includes("terms-and-condition")
                      ? "menu-item active"
                      : "menu-item"
                  }
                >
                  Term and Condition
                </MenuItem>

                {/* Submenu: Sales */}
                {shouldShowParent([
                  "sales order",
                  "invoice",
                  "payment receive",
                ]) && (
                  <SubMenu
                    label="Sales"
                    icon={
                      <NotebookTabs size={20} style={{ marginLeft: "20px" }} />
                    }
                  >
                    {/* {isModuleVisible("sales order") && (
                      <MenuItem
                        icon={<CirclePercent size={20} />}
                        component={<Link to="/sales-order" />}
                        className={location.pathname.includes("sales-order") ? "menu-item active" : "menu-item"}
                        style={{ marginLeft: "40px" }}
                      >
                        Sales Order
                      </MenuItem>
                    )} */}
                    {isModuleVisible("invoice") && (
                      <MenuItem
                        icon={<WalletCards size={20} />}
                        component={<Link to="/invoice" />}
                        className={
                          location.pathname.includes("invoice")
                            ? "menu-item active"
                            : "menu-item"
                        }
                        style={{ marginLeft: "40px" }}
                      >
                        Invoices
                      </MenuItem>
                    )}
                    {isModuleVisible("payment receive") && (
                      <MenuItem
                        icon={<WalletCards size={20} />}
                        component={<Link to="/payment-receive" />}
                        className={
                          location.pathname.includes("payment-receive")
                            ? "menu-item active"
                            : "menu-item"
                        }
                        style={{ marginLeft: "40px" }}
                      >
                        Payment Receive
                      </MenuItem>
                    )}
                  </SubMenu>
                )}

                {/* Submenu: Purchase */}
                {shouldShowParent(["vendor", "purchase order", "bill"]) && (
                  <SubMenu
                    label="Purchase"
                    icon={
                      <ReceiptText size={20} style={{ marginLeft: "20px" }} />
                    }
                  >
                    {isModuleVisible("vendor") && (
                      <MenuItem
                        icon={<Users size={20} />}
                        component={<Link to="/vendor" />}
                        className={
                          location.pathname.includes("vendor")
                            ? "menu-item active"
                            : "menu-item"
                        }
                        style={{ marginLeft: "40px" }}
                      >
                        Vendor
                      </MenuItem>
                    )}
                    {isModuleVisible("purchase order") && (
                      <MenuItem
                        icon={<BriefcaseBusiness size={20} />}
                        component={<Link to="/purchaseOrder-list-view" />}
                        className={
                          location.pathname.includes("purchaseOrder")
                            ? "menu-item active"
                            : "menu-item"
                        }
                        style={{ marginLeft: "40px" }}
                      >
                        Purchase Order
                      </MenuItem>
                    )}
                    {isModuleVisible("bill") && (
                      <MenuItem
                        icon={<NotebookPen size={20} />}
                        component={<Link to="/bill" />}
                        className={
                          location.pathname.includes("bill")
                            ? "menu-item active"
                            : "menu-item"
                        }
                        style={{ marginLeft: "40px" }}
                      >
                        Bill
                      </MenuItem>
                    )}
                  </SubMenu>
                )}
              </SubMenu>
            )}

            {/* HRM Menu */}
            {shouldShowParent(["employee", "attendance", "department"]) && (
              <SubMenu
                label="HRM"
                icon={<Layers3 size={20} />}
                className={
                  isAnySubModuleActive([
                    "employees",
                    "attendance-list",
                    "department-list",
                  ])
                    ? "submenu-active"
                    : ""
                }
              >
                {isModuleVisible("employee") && (
                  <MenuItem
                    icon={<UserRound size={20} />}
                    component={<Link to="/employees" />}
                    className={
                      location.pathname === "/employees" ||
                      location.pathname === "/employee-detail-view"
                        ? "menu-item active"
                        : "menu-item"
                    }
                  >
                    Employees
                  </MenuItem>
                )}
                {/* {isModuleVisible("attendance") && (
                  <MenuItem
                    icon={<FileClock size={20} />}
                    component={<Link to="/attendance-list" />}
                    className={location.pathname === "/attendance-list" || location.pathname === "/attendance-detail-view" ? "menu-item active" : "menu-item"}
                  >
                    Attendance
                  </MenuItem>
                )} */}
                {isModuleVisible("department") && (
                  <MenuItem
                    icon={<Award size={20} />}
                    component={<Link to="/department-list" />}
                    className={
                      location.pathname.includes("department-list")
                        ? "menu-item active"
                        : "menu-item"
                    }
                  >
                    Department
                  </MenuItem>
                )}
              </SubMenu>
            )}
            {/* <MenuItem icon={<Gauge size={20} />} component={<Link to="/dashboard" />} className={location.pathname === '/dashboard' ? 'menu-item active' : 'menu-item'}>Dashboard</MenuItem> */}
          </div>
        </Menu>
      </Sidebar>
    </div>
  );
}

export default Sidenav;
